module.exports = __webpack_public_path__ + "img/720x900-soru-2.a310fa5d.jpg";